import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingPageComponent } from "./pages/landing-page/landing-page.component";
import { FvElectionOverviewComponent } from "./pages/election-overview/general-election/fv-election-overview.component";
import { EvElectionOverviewComponent } from "./pages/election-overview/european-parliament-election/ev-election-overview.component";
import { FaElectionOverviewComponent } from "./pages/election-overview/referendum/fa-election-overview.component";
import { KvElectionOverviewComponent } from "./pages/election-overview/municipal-election/kv-election-overview.component";
import { RvElectionOverviewComponent } from "./pages/election-overview/regional-election/rv-election-overview.component";
import { DetailsNominationDistrictComponent } from './pages/details-page/nomination-district/nomination-district.component';
import { BreadcrumbType } from '@shared/components/breadcrumbs/breadcrumb.model';
import { DetailsRegionComponent } from './pages/details-page/region/region.component';
import { DetailsPollingDistrictComponent } from './pages/details-page/polling-district/polling-district.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { electionContextGuard } from "@shared/guards/election-context-guard";
import { ExportDataPageComponent } from "./pages/export-data-page/export-data-page.component";
import { DetailsMunicipalComponent } from './pages/details-page/municipal/municipal.component';
import { SiteMapComponent } from './pages/site-map/site-map.component';

const routes: Routes = [
  {
    path: '',
    data: {
      breadcrumb: true
    },
    children: [
      {
        path: '',
        component: LandingPageComponent,
        title: "frontpage.title",
        data: {
          breadcrumb: true
        },
      },
      {
        path: 'fv/:electionId',
        data: {
          breadcrumb: true,
          type: BreadcrumbType.GeneralElection
        },
        canActivate: [ electionContextGuard ],
        children: [
          {
            path: '',
            data: {
              breadcrumb: false,
            },
            component: FvElectionOverviewComponent
          },
          {
            path: 'nomination-district/:nominationDistrictId',
            data: {
              breadcrumb: true,
              shouldReload: true,
              type: BreadcrumbType.NominationDistrict
            },
            children: [
              {
                path: '',
                data: {
                  breadcrumb: false,
                },
                component: DetailsNominationDistrictComponent,
              },
              {
                path: 'polling-district/:electionAreaId',
                component: DetailsPollingDistrictComponent,
                data: {
                  breadcrumb: true,
                  type: BreadcrumbType.PollingDistrict
                },
              },
            ]
          },
        ]
      },
      {
        path: 'rv/:electionId',
        data: {
          breadcrumb: true,
          type: BreadcrumbType.RegionalElection
        },
        canActivate: [ electionContextGuard ],
        children: [
          {
            path: '',
            data: {
              breadcrumb: false,
            },
            component: RvElectionOverviewComponent
          },
          {
            path: 'region/:regionId',
            data: {
              breadcrumb: true,
              shouldReload: true,
              type: BreadcrumbType.Region
            },
            children: [
              {
                path: '',
                data: {
                  breadcrumb: false,
                },
                component: DetailsRegionComponent,
              },
              {
                path: 'municipality/:municipalityId',
                data: {
                  breadcrumb: true,
                  type: BreadcrumbType.Municipality
                },
                children: [
                  {
                    path: '',
                    data: {
                      breadcrumb: false,
                    },
                    component: DetailsMunicipalComponent,
                  },
                  {
                    path: 'polling-district/:electionAreaId',
                    component: DetailsPollingDistrictComponent,
                    data: {
                      breadcrumb: true,
                      type: BreadcrumbType.PollingDistrict
                    },
                  }
                ]
              },
            ]
          },
        ]
      },
      {
        path: 'kv/:electionId',
        canActivate: [ electionContextGuard ],
        data: {
          breadcrumb: true,
          type: BreadcrumbType.MunicipalElection
        },
        children: [
          {
            path: '',
            data: {
              breadcrumb: false,
            },
            component: KvElectionOverviewComponent
          },
          {
            path: 'municipality/:municipalityId',
            data: {
              breadcrumb: true,
              shouldReload: true,
              type: BreadcrumbType.Municipality
            },
            children: [
              {
                path: '',
                data: {
                  breadcrumb: false,
                },
                component: DetailsMunicipalComponent,
              },
              {
                path: 'polling-district/:electionAreaId',
                component: DetailsPollingDistrictComponent,
                data: {
                  breadcrumb: true,
                  type: BreadcrumbType.PollingDistrict
                },
              }
            ]
          }
        ]
      },
      {
        path: 'ev/:electionId',
        data: {
          breadcrumb: true,
          type: BreadcrumbType.EuropeanParliamentElection
        },
        canActivate: [ electionContextGuard ],
        children: [
          {
            path: '',
            data: {
              breadcrumb: false,
            },
            component: EvElectionOverviewComponent
          },
          {
            path: 'nomination-district/:nominationDistrictId',
            data: {
              breadcrumb: true,
              shouldReload: true,
              type: BreadcrumbType.NominationDistrict
            },
            children: [
              {
                path: '',
                data: {
                  breadcrumb: false,
                },
                component: DetailsNominationDistrictComponent,
              },
              {
                path: 'polling-district/:electionAreaId',
                component: DetailsPollingDistrictComponent,
                data: {
                  breadcrumb: true,
                  type: BreadcrumbType.PollingDistrict
                },
              },
            ]
          },
        ]
      },
      {
        path: 'fa/:electionId',
        canActivate: [ electionContextGuard ],
        data: {
          breadcrumb: true,
          type: BreadcrumbType.Referendum
        },
        children: [
          {
            path: '',
            data: {
              breadcrumb: false,
            },
            component: FaElectionOverviewComponent
          },
          {
            path: 'nomination-district/:nominationDistrictId',
            data: {
              breadcrumb: true,
              shouldReload: true,
              type: BreadcrumbType.NominationDistrict
            },
            children: [
              {
                path: '',
                data: {
                  breadcrumb: false,
                },
                component: DetailsNominationDistrictComponent,
              },
              {
                path: 'polling-district/:electionAreaId',
                component: DetailsPollingDistrictComponent,
                data: {
                  breadcrumb: true,
                  type: BreadcrumbType.PollingDistrict
                },
              },
            ]
          },
        ]

      },
      {
        path: 'privatlivspolitik-og-brug-af-data',
        component: PrivacyPolicyComponent,
        data: {
          breadcrumb: true,
          type: BreadcrumbType.Page,
          title: "breadcrumb.pages.privacy_policy"
        },
      },
      {
        path: 'data-eksport',
        component: ExportDataPageComponent,
        data: {
          breadcrumb: true,
          type: BreadcrumbType.Page,
          title: "breadcrumb.pages.export_data"
        },
      },
      {
        path: 'sitemap',
        component: SiteMapComponent,
        data: {
          breadcrumb: true,
          type: BreadcrumbType.Page,
          title: "sitemap.title"
        },
      },
    ]
  },
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }
